export function formatRefNumber(contractId: string) {
  return `#${contractId.substring(contractId.length - 5)}`;
}
